export default __webpack_public_path__ + "static/emt-25240f1a05eaa9a88db1dffdc13b3109.jpg";